import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import selectors from '../redux/selectors/index'
import { connect } from 'react-redux'


const mapStateToProps = state => ({
  emailTemplates: selectors.emailTemplates.getCampaignTemplatesOnly(state),
})

const propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

class SelectEmailTemplate extends Component {
  render () {
    const {
      emailTemplates,
      value,
      onChange,
      ...otherProps
    } = this.props

    const options = emailTemplates.map(({ id, name }) => ({
      value: id,
      label: name,
    }))

    return (
      <Select
        type="select"
        name="emailTemplate"
        id="email-templates"
        placeholder=""
        value={options.filter(option => option.value === value)}
        options={options}
        onChange={({ value }) => onChange(value)}
        {...otherProps}
      />
    )
  }
}

SelectEmailTemplate.propTypes = propTypes

export default connect(mapStateToProps)(SelectEmailTemplate)